let sortButtonComponent =  require('../table-components/SortButtonComponent.vue');
let searchBoxComponent =  require('../table-components/SearchBoxComponent.vue');
let paginationComponent =  require('../table-components/PaginationComponent.vue');

export default {

    components: {

        'sort-button': sortButtonComponent,
        'search-box': searchBoxComponent,
        'pagination': paginationComponent,

    },

};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/TableComponentsMixin.js